/**
 * Contractor Portfolio page ("My Portfolio").
 *
 * Single portfolio system: this page now renders the same portfolio manager used
 * in the application flow (cards + photo carousel + add/detail-edit modal, with
 * Google-autocomplete address and a contactable client). The old bespoke editor
 * (description / project type / budget / before-after) was removed so there is one
 * consistent portfolio experience everywhere.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Box, Button } from '@mui/material';
import { ArrowBack, OpenInNew } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import { brand } from '../theme/colors';
import PortfolioReferencesStep from '../components/onboarding/steps/PortfolioReferencesStep';

const ContractorPortfolioPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3, flexWrap: 'wrap', gap: 1 }}>
        <Button startIcon={<ArrowBack />} onClick={() => navigate('/dashboard')} sx={{ color: 'text.secondary' }}>
          Back to Dashboard
        </Button>
        <Button
          variant="outlined"
          startIcon={<OpenInNew />}
          onClick={() => navigate(`/p/contractor/${user?.id}?tab=portfolio&preview=1`)}
          sx={{ borderColor: brand.primary, color: brand.primary, '&:hover': { borderColor: brand.primaryDark } }}
        >
          Preview Owner View
        </Button>
      </Box>

      <PortfolioReferencesStep onChange={() => {}} color={brand.primary} />
    </Container>
  );
};

export default ContractorPortfolioPage;
